import _ from "lodash";
import {SOFTWARE_PRODUCT_CONTENT_FALLBACKS} from "./constants";

/**
 * Dress up the core resellable software product "Hike" for use on the front-end.
 */
export function softwareProduct({softwareProduct}) {
  const { minimised, name, description } = softwareProduct;
  let { prices } = softwareProduct;

  const fallbackName = SOFTWARE_PRODUCT_CONTENT_FALLBACKS.name;

  return {
    name,
    description,
    fallbackName,
    prices,
    minimised,
  };
}

/**
 * Dress up the core resellable software product "Done With You" for use on the front-end.
 */
export function supportAddon({supportAddon}) {
  const { minimised, name, description } = supportAddon;
  let { prices } = supportAddon;

  const fallbackName = SOFTWARE_PRODUCT_CONTENT_FALLBACKS.name;

  return {
    name,
    description,
    fallbackName,
    prices,
    minimised,
  };
}

export default {
  softwareProduct,
  supportAddon,
  supportedCurrencies: ({supportedCurrencies}) => supportedCurrencies,
  softwarePrices: ({softwarePrices}) => softwarePrices,
  resaleAddons: ({resaleAddons}) => resaleAddons,
  errors: ({errors}) => errors,
  enableSupportAddon: ({enableSupportAddon}) => enableSupportAddon,
  loading: ({loading}) => loading,
};
